import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class Globals {
  constructor() {}

  apiUrl(params: string): string {
    return `${environment.baseUrl}api/${params}`;
  }

  adminUrl(params: string): string {
    return `${environment.baseUrl}api/rocketmaster/${params}`;
  }

  stripePublishableKey(): string {
    return environment.stripe_publishable_key;
  }

  openOcppIntegrationWiki(): void {
    this.openLink(
      'https://sites.google.com/smart-me.com/ecarup-wiki/ocpp-ladestationen'
    );
  }

  openAgb(): void {
    this.openLink('http://web.ecarup.com/agb/');
  }

  openLink(href: string): void {
    window.open(href, '_blank');
  }
}
